import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import WebFont from "webfontloader";
import { addLocaleData } from "react-intl";
import locale_pl from "react-intl/locale-data/pl";
import locale_en from "react-intl/locale-data/en";

addLocaleData([...locale_pl, ...locale_en]);

WebFont.load({
  google: {
    families: ["Work Sans:400,700", "sans-serif"],
  },
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Route component={App} />
    </Router>
  </Provider>,
  document.getElementById("root")
);
